import { Box } from '@mui/material';
import React from 'react';
import StoreAddSection from '../component/StoreAddSection';

const AddStorePage = () => {
	return (
		<Box sx={{ height: '100%', bgcolor: '#fff' }}>
			<StoreAddSection />
		</Box>
	);
};

export default AddStorePage;
